import "core-js/fn/array/flat-map";

import obsidian from "@obsidianjs/obsidian";
import stonejs from "@obsidianjs/stonejs";
import httpRequest from "@obsidianjs/http-request";

import InternationalizationUtility from "./modules/internationalization-utility";
import Vuejs from "./modules/vuejs";
import PaintingLib from "./modules/painting-lib";

import "./style/index.scss";

const app = obsidian("starter-app");

// Internationalization modules
app.use(stonejs);
app.use(InternationalizationUtility);
// ////

app.use(httpRequest);
app.use(Vuejs);
app.use(PaintingLib);

app.start();
